import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgGreenInvoice = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={80}
    height={80}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <circle cx={40} cy={40} r={40} fill="#DDF7F1" />
    <g clipPath="url(#greenInvoice_svg__a)" fill="#0CC28A">
      <path d="M49.808 48.928h-22.43c-.51 0-.947.418-.947.906 0 .489.437.907.947.907H49.88c.51 0 .946-.418.946-.907 0-.488-.51-.906-1.02-.906ZM43.982 53.46H27.378c-.51 0-.947.35-.947.838s.437.907.947.907h16.677c.51 0 .946-.419.946-.907 0-.488-.51-.837-1.02-.837Z" />
      <path d="m57.309 26.33-8.74-8.717c-.145-.21-.436-.279-.655-.279h-22.72c-2.113 0-3.86 1.674-3.86 3.696v38.01c0 2.023 1.747 3.627 3.86 3.627h28.62c2.111 0 3.859-1.674 3.859-3.696V26.889c-.073-.14-.218-.419-.364-.558Zm-2.403.14h-4.443c-1.092 0-2.039-.836-2.039-1.952v-4.534l6.482 6.486ZM53.74 60.924H25.193c-1.092 0-2.039-.837-2.039-1.953V21.03c0-1.047.874-1.953 2.04-1.953h21.482v5.51c0 2.022 1.748 3.696 3.86 3.696h5.243V59.11c0 .977-.946 1.814-2.039 1.814Z" />
      <path d="M50.318 29.957H28.543c-1.384 0-2.476 1.046-2.476 2.302v9.833c0 1.256 1.092 2.302 2.476 2.302h21.774c1.384 0 2.477-1.046 2.477-2.302V32.26c0-1.326-1.093-2.302-2.476-2.302Zm.655 2.232v4.045h-6.336v-4.603h5.68c.365.07.656.279.656.558ZM42.817 42.65h-6.409v-4.603h6.409v4.603Zm-6.409-6.346V31.7h6.409v4.603h-6.409Zm-8.52-4.115c0-.28.29-.558.655-.558h6.044v4.603h-6.7v-4.045Zm0 9.903v-4.045h6.627v4.603h-5.972c-.364 0-.655-.279-.655-.558Zm23.085 0c0 .28-.291.558-.655.558h-5.68v-4.603h6.335v4.045Z" />
    </g>
    <defs>
      <clipPath id="greenInvoice_svg__a">
        <path
          fill="#fff"
          transform="translate(21.334 17.334)"
          d="M0 0h36.267v45.333H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgGreenInvoice);
export default ForwardRef;
